import { settings } from 'app/core/settings';
var AuthFooterComponent = /** @class */ (function () {
    function AuthFooterComponent() {
    }
    Object.defineProperty(AuthFooterComponent.prototype, "settings", {
        get: function () {
            return settings;
        },
        enumerable: true,
        configurable: true
    });
    return AuthFooterComponent;
}());
export { AuthFooterComponent };
